import React, { Children } from 'react';
import { Section } from './ui/Section';
import { BookOpen, Eye, Move, Calendar, CheckSquare, BookA } from 'lucide-react';
import { motion } from 'framer-motion';
const deliverables = [{
  icon: BookOpen,
  title: "The Elite Striker's IQ Map",
  desc: 'Full Digital Playbook'
}, {
  icon: Eye,
  title: 'The 3-Step Mbappé Scan Protocol',
  desc: 'Step-by-Step Instructions'
}, {
  icon: Move,
  title: "The 'L-Move' Framework",
  desc: 'For Losing Elite Markers'
}, {
  icon: Calendar,
  title: '14-Day Cognitive IQ Blueprint',
  desc: 'Daily 10-Minute Training Schedule'
}, {
  icon: CheckSquare,
  title: "The 'Sideline Scout' Checklist",
  desc: 'Parent Checklist & Post-Game Worksheet'
}, {
  icon: BookA,
  title: 'Glossary of Elite Terms',
  desc: 'Master the cognitive language'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function DeliverablesSection() {
  return <Section className="bg-tactical-surface/30" data-id="element-47">
      <div className="text-center mb-16" data-id="element-48">
        <h2 className="text-4xl md:text-5xl mb-4" data-id="element-49">WHAT YOU GET</h2>
        <div className="w-24 h-1 bg-tactical-cyan mx-auto rounded-full" data-id="element-50"></div>
      </div>

      <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-51">
        {deliverables.map((item, i) => <motion.div key={i} variants={itemVariants} className="bg-tactical-surface border border-tactical-surface2 p-6 rounded-xl hover:border-tactical-cyan/50 transition-colors group" data-id="element-52">
            <div className="w-12 h-12 bg-tactical-dark rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-53">
              <item.icon className="w-6 h-6 text-tactical-cyan" data-id="element-54" />
            </div>
            <h3 className="text-xl mb-2" data-id="element-55">{item.title}</h3>
            <p className="text-slate-400 font-inter text-sm" data-id="element-56">{item.desc}</p>
          </motion.div>)}
      </motion.div>
    </Section>;
}